<div class="register-entrance-combined mat-body">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'Accept Entrance' | translate: ['tmc.transport.register-entrance-combined.title',
      translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="grid">

        <div class="options-list" style="grid-column: 1; grid-row: 1;">
          <div class="form-box">
            <h3>
              {{'supplementary equipment' | translate:
              ['tmc.transport.register-entrance-combined.supplementaryequipment.title',
              translationService.language]}}
            </h3>
            <div class="se-grid">

              <div class="form-checkbox" style="grid-column: 1 / span 2; grid-row: 1;"
                *ngIf="cps.isEnabled(clientParameters.FEATURE_FORCE_SUPPLEMENTARY_EQUIPMENT_CONFIRMATION, true)">
                <mat-checkbox [(ngModel)]="seTransport.noSupplementaryEquipmentHandout"
                  [ngModelOptions]="{standalone: true}"
                  [disabled]="isNoSupplementaryEquipmentHandoutDisabled() || isFormReadonly()">
                  {{'no supplementary equipment handout' | translate:
                  ['tmc.transport.register-entrance-combined.label.nosupplementaryequipmenthandout',
                  translationService.language]}}
                </mat-checkbox>
              </div>

              <ng-container *ngFor="let se of seTransport.supplementaryEquipments; let i = index">

                <div class="center" style="grid-column: 1;" [ngStyle]="{'grid-row': i + getRowOffset() }">
                  <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}"
                    [disabled]="isNoSupplementaryEquipmentHandoutSelected() || isFormReadonly()">
                    {{se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]}}</mat-checkbox>
                </div>

                <mat-form-field *ngIf="isStringParameter(se)" style="grid-column: 2;"
                  [ngStyle]="{'grid-row': i + getRowOffset() }">
                  <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}" required
                    [disabled]="!se.selected || isFormReadonly()" [readonly]="isFormReadonly()"
                    placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
                </mat-form-field>

                <mat-form-field *ngIf="isNumberParameter(se)" style="grid-column: 2;"
                  [ngStyle]="{'grid-row': i + getRowOffset() }">
                  <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value"
                    [ngModelOptions]="{standalone: true}" required [disabled]="!se.selected || isFormReadonly()"
                    [readonly]="isFormReadonly()"
                    placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
                </mat-form-field>

              </ng-container>

            </div>
          </div>
        </div>

        <form #weighForm="ngForm" class="weigh-input-form" style="grid-column: 2; grid-row: 1;"
          *ngIf="isWeighingActive()">
          <div class="form-box">
            <h3>
              {{'weigh transport' | translate: ['tmc.transport.register-entrance-combined.weighing.title',
              translationService.language]}}
            </h3>
            <div class="flex-direction-row row-flex">
              <mat-form-field class="flex-grow-1">
                <input name="value" matInput [(ngModel)]="transport.weight" #ctrlValue="ngModel" type="number" min="0"
                  placeholder="{{'weight' | translate: ['tmc.transport.register-entrance-combined.weight', translationService.language]}}"
                  [readonly]="isFormReadonly()"
                  [required]="cps.isRequired(clientParameters.P_VISITOVERVIEW_REGISTER_LEAVE_MINLENGHT_WEIGHT, false)"
                  appPositiveInteger>
                <mat-error *ngIf="showValuePositiveIntegerError(ctrlValue)">
                  {{'value must positive and Integer' | translate: ['tmc.weigh-transport-dialog.error.value-no-integer',
                  translationService.language]}}
                </mat-error>
              </mat-form-field>
              <button mat-icon-button class="weighingButton" (click)="readWeight()" [hidden]="isAutoWeighingVisible()"
                [matTooltip]="'Weigh Transport' | translate: ['tmc.visit.overview.action.weighTransport', translationService.language]"
                *ngIf="cps.isEnabled(clientParameters.P_VISITS_WEIGHING_ENABLED, false)">
                <sc-icon iconClass="fa-balance-scale"></sc-icon>
              </button>
              <mat-form-field class="margin-left">
                <mat-label>
                  {{'type' | translate: ['tmc.transport.register-entrance-combined.weighingType',
                  translationService.language]}}
                </mat-label>
                <mat-select name="type" [(ngModel)]="transport.weighingType" #ctrlType="ngModel"
                  [required]="isWeighingTypeRequired()" [value]="transport.weighingType" [disabled]=isFormReadonly()>
                  <mat-option *ngFor="let o of typeOptions" value="{{o}}">
                    {{o | translate: ['tmc.transport.register-entrance-combined.weighingType.' + o,
                    translationService.language]}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="form-box" style="grid-column: 1 / span 2; grid-row: 2;">
          <h3>
            {{'hints' | translate: ['tmc.transport.register-entrance-combined.checks.title',
            translationService.language]}}
          </h3>
          <div class="checks-list">
            <ul *ngIf="checksExist(transport)">
              <li class="check" *ngFor="let check of transport.checks">
                <div class="icon">
                  <i class="fa-light" [ngClass]="{
                      'fa-check color-ok': isOk(check), 
                      'fa-exclamation-triangle color-warn': isWarning(check), 
                      'fa-exclamation-circle color-error': isFailed(check),
                      'fa-info': isInfo(check)
                    }"></i>
                </div>
                <div class="message">
                  {{check.nameDictionaryKey | translate: [check.nameDictionaryKey, translationService.language]}}
                  <ng-container *ngIf="descriptionExists(check)">
                    -
                    {{check.descriptionDictionaryKey | translate: [check.descriptionDictionaryKey,
                    translationService.language]}}
                  </ng-container>
                </div>
              </li>
            </ul>
            <span *ngIf="!checksExist(transport)">{{'Keine Hinweise' | translate:
              ['tmc.transport.register-entrance-combined.checks.nochecks', translationService.language]}}</span>
          </div>
        </div>
      </div>
    </div>

    <i class="horizontal-divider"></i>
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
        ['tmc.transport.register-entrance-combined.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="decline()" [disabled]="isDeclineDisabled()">{{'decline' | translate:
        ['tmc.transport.register-entrance-combined.action.decline', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="accept()" class="confirm-button" [disabled]="isAcceptDisabled()">{{'accept' |
        translate: ['tmc.transport.register-entrance-combined.action.accept',
        translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>